import React, { lazy, Suspense } from 'react'

// import FounderProfile from './FounderProfile'
import { Link } from 'react-router-dom'
const Hero = lazy(() => import('./inner_components/Hero'))

const AboutPage = () => {
  const stats = [
    { value: '15+', label: 'Years Experience' },
    { value: '99%', label: 'Client Satisfaction' },
    { value: '500+', label: 'Employee Transport' },
    { value: '24/7', label: 'Support' },
  ]

  return (
    <div className="min-h-screen">
      <Suspense
        fallback={<div className="h-[35rem] bg-gray-200 animate-pulse" />}
      >
        {/* Hero Section */}
        <div className="top-" data-aos="fade-down" data-aos-duration="400">
          <Hero
            tagline="About Us"
            title="Our Story"
            description="Read more about our corporate transportation success and how we might help."
            bgImage="/images/aboutus.jpg"
          />
        </div>
      </Suspense>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-16 relative z-10">
        {/* Introduction Section */}
        <div
          className="bg-white rounded-lg shadow-xl p-8 mb-12"
          data-aos="fade-up"
          data-aos-duration="100"
        >
          <h2
            className="text-3xl font-bold mb-6"
            data-aos="fade-up"
            data-aos-duration="400"
          >
            We help with Employee Transportation
          </h2>
          <p
            className="text-gray-600 leading-relaxed mb-8"
            data-aos="fade-up"
            data-aos-delay="150"
            data-aos-duration="500"
          >
            At RoyalRise Tours & Travels, we specialize in providing seamless
            and reliable employee transportation solutions for corporate clients
            across Karnataka. Our mission is to simplify commutes and enhance
            employee satisfaction through safe, efficient, and cost-effective
            services.
          </p>

          <div
            className="flex flex-wrap gap-4"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <Link
              to="/service"
              className="hover:bg-[#3180c1] bg-[#1865a5] text-white px-6 py-2 rounded-full"
            >
              Services
            </Link>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center"
              data-aos="zoom-in"
              data-aos-delay={index * 50}
              data-aos-duration="500"
            >
              <div className="text-4xl font-bold text-purple-900">
                {stat.value}
              </div>
              <div className="text-gray-600 mt-2">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Mission & Vision Section */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div
            className="bg-white rounded-lg shadow-lg p-8"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <h3 className="text-2xl font-bold mb-4 text-purple-900">
              Our Mission
            </h3>
            <p className="text-gray-600 leading-relaxed">
              To provide safe, reliable, and cost-effective employee
              transportation solutions tailored to corporate needs, ensuring a
              seamless commute that enhances employee satisfaction and
              productivity. We are committed to delivering exceptional service
              through innovation, safety, and a customer-centric approach.
            </p>
          </div>
          <div
            className="bg-white rounded-lg shadow-lg p-8"
            data-aos="fade-left"
            data-aos-duration="500"
          >
            <h3 className="text-2xl font-bold mb-4 text-purple-900">
              Our Vision
            </h3>
            <p className="text-gray-600 leading-relaxed">
              To become the most trusted and preferred partner for corporate
              transportation solutions, setting industry benchmarks for quality,
              safety, and efficiency, while expanding our services across India
              and embracing sustainable practices.
            </p>
          </div>
        </div>

        {/* Company Background Section */}
        <div
          className="bg-purple-50 rounded-lg p-8 mb-16"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          <h3 className="text-2xl font-bold mb-4 text-purple-900">
            Company Background
          </h3>
          <p className="text-gray-600 leading-relaxed">
            Though newly established, RoyalRise Tours and Travels is built on a
            strong foundation of over 15 years of expertise in corporate
            transportation. Our leadership team, with extensive industry
            experience, is committed to redefining business travel by setting
            new benchmarks for quality, reliability, and service excellence. At
            RoyalRise, we understand that corporate travel is more than just
            transportation—it’s about efficiency, comfort, and trust. With our
            promise to help you "Travel with ease, work with peace," we ensure
            every journey is seamlessly managed, allowing you to focus on your
            business while we take care of the rest. Experience hassle-free
            travel solutions tailored to your company's needs — because when
            travel is smooth, work flows effortlessly.
          </p>
        </div>

        {/* Founder Profile Section — temporarily hidden
        <div data-aos="fade-up" data-aos-duration="500">
          <FounderProfile />
        </div>
        */}
      </div>
    </div>
  )
}

export default AboutPage
